module.exports = __webpack_public_path__ + "static/media/resetResend.3c0a69f3.svg";